import { Routes as WebRoutes, Route, Navigate } from 'react-router';
import { useSelector } from 'react-redux';

import Home from './pages/Home/Home';
import { DarkThemeLayout } from './layouts/DarkThemeLayout';
import { LightThemeLayout } from './layouts/LightThemeLayout';
import Contact from './pages/Contact/Contact';
import Faq from './pages/Faq/Faq';
import { NotFound } from './pages/NotFound/NotFound';
import Channels from './pages/Channels/Channels';
import Pricing from './pages/Pricing/Pricing';
import PrivacyPolicy from './pages/Legal/PrivacyPolicy';
import TermsConditions from './pages/Legal/TermsConditions';
import RefundPolicy from './pages/Legal/RefundPolicy';
import FreeTrial from './pages/FreeTrial/FreeTrial';
import FreeTrialSuccess from './pages/FreeTrial/FreeTrialSuccess';
import AdminLayout from './layouts/AdminLayout';
import AdminDashboard from './pages/Admin/AdminDashboard';
import Login from './pages/Login/Login';
import { AuthLayout } from './layouts/AuthLayout';
import Register from './pages/Register/Register';
import AdminRoute from './auth/AdminRoute';
import { AdminTrials } from './pages/Admin/AdminTrials';
import AdminSettings from './pages/Admin/AdminSettings';
import AdminContact from './pages/Admin/AdminContact';
import EuroQualifiers from './pages/LandingPages/EuroQualifiers';
import { HeaderlessLayout } from './layouts/HeaderlessLayout';

export default function Routes() {
  const user = useSelector((state) => state.userLogin);
  return (
    <WebRoutes>
      <Route element={<DarkThemeLayout />}>
        <Route path="/" Component={Home} exact></Route>
      </Route>
      <Route element={<LightThemeLayout />}>
        <Route path="*" Component={NotFound}></Route>
        <Route path="/contact" Component={Contact}></Route>
        <Route path="/faq" Component={Faq}></Route>
        <Route path="/channels" Component={Channels}></Route>
        <Route path="/pricing" Component={Pricing}></Route>
        <Route path="/privacy-policy" Component={PrivacyPolicy}></Route>
        <Route path="/terms-and-conditions" Component={TermsConditions}></Route>
        <Route path="/refund-policy" Component={RefundPolicy}></Route>
        <Route path="/free-trial" Component={FreeTrial}></Route>
        <Route path="/trial-success" Component={FreeTrialSuccess}></Route>
      </Route>

      {/* Auth Layout */}
      <Route element={user.userInfo ? <Navigate to={'/'} /> : <AuthLayout />}>
        <Route path="/login" Component={Login}></Route>
        <Route path="/register" Component={Register}></Route>
      </Route>

      {/* Headerless Layout */}
      <Route element={<HeaderlessLayout />}>
        <Route path="/uefa-euro-qualifiers" Component={EuroQualifiers}></Route>
      </Route>

      {/* Admin Layout */}
      <Route
        element={
          <AdminRoute>
            <AdminLayout />
          </AdminRoute>
        }
      >
        <Route path="/admin" element={<AdminDashboard />}></Route>
        <Route path="/admin/trials" element={<AdminTrials />}></Route>
        <Route path="/admin/settings" element={<AdminSettings />}></Route>
        <Route path="/admin/contact" element={<AdminContact />}></Route>
      </Route>
    </WebRoutes>
  );
}
